import Vue from 'vue'
import * as SentryClient from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

const ignoredSentryErrorCodes = [400, 401, 403, 404]

/**
 * @param   {object}  sentryEvent
 * @param   {object}  sentryHint
 *
 * @returns {boolean}
 */
const isAllowedSentryException = (sentryEvent, sentryHint) => {
  if (
    sentryHint.originalException &&
    sentryHint.originalException.response &&
    ignoredSentryErrorCodes.includes(
      sentryHint.originalException.response.status
    )
  ) {
    return false
  } else {
    return true
  }
}

/**
 * @param {string} email
 */
const identifyUserByEmail = email => {
  SentryClient.configureScope(scope => {
    scope.setUser({
      email
    })
  })
}

/**
 * @param {string} styleId
 * @param {string} boardId
 */
const reportMissingStylesImage = (styleId, boardId) => {
  SentryClient.captureException(
    new Error(
      `Board Export. Missing a image or images on Styles ID: ${styleId} from Board ID: ${boardId}`
    )
  )
}

/**
 */
const initialize = () => {
  if (
    ['staging', 'production'].includes(process.env.VUE_APP_ENVIRONMENT)
  ) {
    SentryClient.init({
      dsn: process.env.SENTRY_DSN,
      release: process.env.SENTRY_RELEASE,
      environment: process.env.VUE_APP_ENVIRONMENT,
      integrations: [new Integrations.Vue({ Vue, logErrors: true })],

      /**
       * @param   {Event}        event
       * @param   {object}       hint
       *
       * @returns {Event | null}
       */
      beforeSend (event, hint) {
        if (isAllowedSentryException(event, hint)) {
          return event
        } else {
          return null
        }
      }
    })
  } else {
    console.debug(
      'Not configuring Sentry, environment is',
      process.env.VUE_APP_ENVIRONMENT
    )
  }
}

const Sentry = {
  initialize,
  identifyUserByEmail,
  reportMissingStylesImage
}

export default Sentry
